import { useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary } from '@/api/generated/conversations/conversations';
import { useAuthStore } from '@/stores/useAuthStore';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';

export const useUnreadSummary = () => {
  const { isAuthenticated } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  const { data, isLoading, error } = useGetApiWorkspacesWorkspaceIdConversationsUnreadSummary(
    activeWorkspaceId!,
    {
      query: {
        enabled: isAuthenticated && !!activeWorkspaceId,
        staleTime: 30000,
        refetchOnWindowFocus: true,
      }
    }
  );

  const summaryData = data as any;
  const count = summaryData?.totalUnreadConversations ?? 0;
  
  // Create a dictionary for fast store lookups
  const storeCounts = summaryData?.stores?.reduce((acc: any, store: any) => {
    if (store.storeId && typeof store.unreadConversations === 'number') {
      acc[store.storeId] = store.unreadConversations;
    }
    return acc;
  }, {} as Record<string, number>) || {};

  return {
    data,
    count,
    formattedBadge: count > 99 ? '99+' : count > 0 ? String(count) : undefined,
    storeCounts,
    isLoading,
    error,
  };
};

export default useUnreadSummary;
